import { fetchPrivilegiosUsuario } from './privilegios';
import { setUserHeader } from './user';

/**
 * Acción para cargar privilegios del usuario autenticado después del login
 * @param {string} usuarioId - ID del usuario autenticado
 */
export const cargarPrivilegiosAlLogin = (usuarioId) => async (dispatch) => {
  // Primero refresca los datos del usuario (opcional, si ya tienes el user puedes omitir)
  await dispatch(setUserHeader());
  // Luego carga los privilegios del usuario
  await dispatch(fetchPrivilegiosUsuario(usuarioId));
};
